import React from 'react';
import { Zap } from 'lucide-react';

const LoginMarketingPanel = () => {
  return (
    <aside className="auth-login__marketing" aria-hidden="false">
      <div className="auth-login__marketing-bg" />
      <div className="auth-login__grid" aria-hidden="true" />

      <div className="auth-login__hero">
        <img src="/images/login-left-hero.png" alt="" />
        <div className="auth-login__hero-fade" aria-hidden="true" />
      </div>

      <div className="auth-login__marketing-content">
        <a href="/" className="auth-login__logo" aria-label="ABET Partners">
          <img src="/images/Logo-White.png" alt="ABET Partners" />
        </a>

        <span className="auth-login__badge">
          <Zap aria-hidden="true" />
          Powering Partnerships. Building Success.
        </span>

        <h1 className="auth-login__headline">
          Grow Your Network.
          <br />
          <span className="auth-login__headline-accent">Earn Unlimited Commissions.</span>
        </h1>

        <p className="auth-login__copy">
          Join our global partner program and earn lifetime commissions by referring active
          traders. The more you refer, the more you earn.
        </p>
      </div>
    </aside>
  );
};

export default LoginMarketingPanel;
